import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { AnimationModal } from '@nfs-react/components';

import FormBlock from './FormBlock';
import { FormWrapperStyles } from '../UI/UI';

const FormFixed = ({ closePopup, isOpen }) => {
  return (
    <AnimationModal
      onClose={closePopup}
      open={isOpen}
      formMaxWidth='368'
      showCloseIcon
    >
      <FormWrapper>
        <FormBlock />
      </FormWrapper>
    </AnimationModal>
  );
};

const FormWrapper = styled.div`
  ${FormWrapperStyles}
`;

FormFixed.propTypes = {
  closePopup: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

export default FormFixed;
